import React from 'react';

/**
 * 🎯 SUB-LIST TOGGLE CONTROL
 * Controls the UI visibility of the child resource sub-list/slide-out.
 */
export const DisplayToggleControl = ({ isVisible, onToggle }) => (
    <button 
        className={`btn btn-xs fw-bold ${isVisible ? 'btn-secondary' : 'btn-outline-primary'}`}
        onClick={onToggle}
        style={{ fontSize: '0.65rem', padding: '2px 8px', minWidth: '60px' }}
        type="button"
    >
        {isVisible ? "HIDE" : "SHOW"}
    </button>
);

/**
 * 🎯 ADD CONTROL
 * Standard submission for new generic entries.
 */
export const AddEntryControl = ({ onAdd }) => (
    <button 
        className="btn btn-xs btn-outline-success fw-bold shadow-none" 
        onClick={onAdd}
        type="button"
        style={{ padding: '2px 8px' }}
    >
        <i className="bi bi-plus-lg"></i>
    </button>
);